const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-trash" */ '@/pages/financial/tariff/trash/trash-tariff/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-trash" */ '@/pages/financial/tariff/trash/trash-tariff/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-trash" */ '@/pages/financial/tariff/trash/trash-tariff/edit.vue'
  )

export default {
  name: 'TrashTariff',
  path: 'trash-tariff',
  meta: {
    label: 'trash',
    auth: 'trash'
  },
  component: {
    name: 'Trash',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffTrashReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateTrashTariff',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditTrashTariff',
      path: 'edit/:id',
      meta: {
        label: 'update',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
